<div class="modal fade" id="modalLabCompare" tabindex="-1" role="dialog" aria-labelledby="modalLabCompareLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Compare Last Lab Test</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

                <div class="mb-3">
                    <label class="text-muted small mb-2 d-block">Select Labs to Compare</label>
                    <div class="d-flex align-items-center justify-content-between flex-wrap">
                        <div class="lab-checkbox-row">
                            <div class="form-check form-check-inline lab-checkbox-lg" *ngFor="let lab of petService.lab_test">
                                <input class="form-check-input" type="checkbox" [id]="'labchk-' + lab"
                                    [checked]="isLabSelected(lab)" (change)="toggleLab(lab)">
                                <label class="form-check-label" [for]="'labchk-' + lab">{{lab}}</label>
                            </div>
                        </div>
                        <button type="button" class="btn btn-primary lab-compare-btn" (click)="onCompare()">
                            <i class="las la-not-equal"></i> Compare
                        </button>
                    </div>
                </div>

                <div class="col-lg-12 my-3 separator separator-dashed"></div>

                <ng-container *ngIf="matched.length > 0">
                    <h4 class="text-center mb-2 mt-4">Similar Test</h4>

                    <div class="table-responsive">
                        <table class="table table-bordered lab-compare-table">
                            <thead>
                                <tr>
                                    <th>Similar Test</th>
                                    <th *ngFor="let lab of compared_labs" [style.color]="labColor(lab)">{{lab}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of matched">
                                    <td>
                                        <button type="button" class="btn btn-icon w-25px h-25px btn-info lab-compare-chart-btn" (click)="showChart(row)" title="View history chart">
                                            <i class="las la-chart-line"></i>
                                        </button>
                                        {{row.test_desc}}
                                    </td>
                                    <td *ngFor="let lab of compared_labs">
                                        <ng-container *ngIf="row.values[lab]; else noValue">
                                            {{row.values[lab].val}} {{row.values[lab].unit}} <span class="lab-compare-date">{{row.values[lab].date | date:'MM/dd/yyyy'}}</span>
                                        </ng-container>
                                        <ng-template #noValue>&mdash;</ng-template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card lab-compare-chart-card" *ngIf="chartOptions">
                        <div class="card-header">
                            <h3 class="card-title">{{chartTitle}} History</h3>
                        </div>
                        <div class="card-body">
                            <div class="row flex-wrap">
                                <div class="col lab-unique-col" *ngFor="let entry of chartHistoryByLab">
                                    <div class="lab-history-label">
                                        <span class="lab-color-swatch" [style.background-color]="labColor(entry.lab)"></span>
                                        {{entry.lab}}
                                    </div>
                                    <div class="table-responsive">
                                        <table class="table table-sm table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Value</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of entry.records">
                                                    <td>{{item.labtest_val}} {{item.units}}</td>
                                                    <td>{{item.labtest_date | date:'MM/dd/yyyy hh:mm a'}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div class="lab-compare-chart-divider"></div>

                            <div echarts [options]="chartOptions" class="lab-compare-chart"></div>
                        </div>
                    </div>

                    <div class="col-lg-12 my-3 separator separator-dashed"></div>
                </ng-container>

                <h4 class="text-center mb-2 mt-4" *ngIf="unique.length > 0">Unique Test</h4>

                <div class="row flex-wrap" *ngIf="unique.length > 0">
                    <div class="col lab-unique-col" *ngFor="let entry of unique">
                        <table class="table table-bordered lab-compare-table">
                            <thead>
                                <tr>
                                    <th colspan="2" [style.color]="labColor(entry.lab)">{{entry.lab}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of entry.records">
                                    <td>{{row.test_desc}}</td>
                                    <td>{{row.labtest_val}} {{row.units}} <span class="lab-compare-date">{{row.labtest_date | date:'MM/dd/yyyy'}}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
